import { webSocketUrls } from "@faire/deprecated-retailer-visitor-shared/lib/webSocketUrls";
import { WebSocketChannelStore } from "@faire/deprecated-retailer-visitor-shared/stores/WebSocketChannelStore";
import { MessageSubscriber } from "@faire/messenger/MessageChannel/MessageChannel";
import { ConductorSurface } from "@faire/web-api--source/indigofair/data/ConductorSurface";
import { IWebSocketMessage } from "@faire/web-api--source/indigofair/websockets/IWebSocketMessage";
import { useCallback, useEffect } from "react";

export const useConductorInvalidationListenerEffect = ({
  surface,
  invalidationCallback,
  listenForBackendInvalidation = false,
}: {
  surface?: keyof typeof ConductorSurface;
  invalidationCallback: () => void;
  listenForBackendInvalidation?: boolean;
}) => {
  const handleInvalidationCallback: MessageSubscriber = useCallback(
    (message) => {
      if (
        surface &&
        message.type === IWebSocketMessage.Type.CONDUCTOR_CAMPAIGN_UPDATED &&
        message.conductor_campaign_updated?.surfaces?.includes(surface)
      ) {
        invalidationCallback();
      }
    },
    [invalidationCallback, surface]
  );

  useEffect(() => {
    if (!listenForBackendInvalidation || !surface) {
      return;
    }

    const websocketChannel = WebSocketChannelStore.get().getOrInitChannel(
      webSocketUrls.faireGeneral()
    );

    if (!websocketChannel) {
      return;
    }

    const listenerHandle = websocketChannel.subscribe(
      handleInvalidationCallback
    );

    return () => websocketChannel.unsubscribe(listenerHandle);
  }, [listenForBackendInvalidation, handleInvalidationCallback, surface]);
};
